module.exports = __webpack_public_path__ + "static/media/kyc-page-1.fe9d476e.png";